import { useDynamicLessonStateContext } from '../../../../hooks/useCreateLessonState';
import { LLMMessageDTO } from '../../../../services/backendService/backendService';

export type AgentChatMessage = Pick<Partial<LLMMessageDTO>, 'attachments'> &
  Pick<LLMMessageDTO, 'role' | 'content' | 'id'> & {
    isStreamingMessage: boolean;
  };

export function useAgentHistoryMessages(): Array<AgentChatMessage> {
  const {
    currentContent: streamingContent,
    isStreaming,
    state: agentState,
    agentHistory,
  } = useDynamicLessonStateContext(context => context.dynamicLessonState.agent);

  //   const messageId

  const messages: AgentChatMessage[] = agentHistory
    .filter(message => !isToolCall(message))
    .map(({ role, content, id, attachments }) => ({
      role,
      content,
      id,
      attachments,
      isStreamingMessage: false,
    }));

  const latestMessage = messages[messages.length - 1];
  // this is a hacky way to prevent ui jerkiness
  // we need to handle this via react query cache so that we use streamed tokens toupdate the content of the message in the query cache
  // and then update the message in the query cache with a real ID, etc once the message is actually received from the server
  const excludeStreaming =
    streamingContent.length > 0 &&
    latestMessage?.role === 'ASSISTANT' &&
    latestMessage?.content?.startsWith(streamingContent);

  if ((isStreaming || agentState) && !excludeStreaming) {
    messages.push({
      role: 'ASSISTANT',
      content: streamingContent,
      id: `streaming`,
      isStreamingMessage: true,
    });
  }

  //absolute hack to ensure the last 2 elements in the message array are not the same content
  if (
    messages[messages.length - 1]?.content === messages[messages.length - 2]?.content &&
    messages[messages.length - 1]?.role === 'ASSISTANT' &&
    messages[messages.length - 2]?.role === 'ASSISTANT'
  ) {
    messages.pop();
  }
  return messages;
}

export function isToolCall(message: LLMMessageDTO): boolean {
  return message.role === 'ASSISTANT' && message.content == null;
}
